
import {Vue, Component} from 'vue-property-decorator';
import {integrityApi} from "@/api/integrity";

const {regionData, CodeToText} = require("@/js/region/region");
import SelectMechanism from "@/components/SelectMechanism.vue";
import ckeditor4 from "@/components/CkeditorComponent.vue";
import CreditListCommon from "@/views/integrity/CreditListCommon.vue";
import {dictApi} from "@/api/organization";
import SelectBasis from "@/views/integrity/components/selectBasis.vue";

@Component({
  components: {
    SelectBasis,
    CreditListCommon,
    ckeditor4, SelectMechanism
  }
})
export default class Order extends Vue {
  private dataList = [];// 企业列表
  private showQuery = false;
  private loading = false;
  private queryParams = {
    start: '',
    end: '',
    punishStart: '',
    punishEnd: '',
    typeName: '',
    recognitionBasisName: '',
    punishingAuthorityName: '',
    documentNumber: '',
    current: 1,
    size: 10,
    total: 0
  }
  userData = {} as any;
  private showAddDialog = false;
  private formRule = {
    punishedUnitName: [{required: true, message: '请输入', trigger: 'change'}],
    documentNumber: [{required: true, message: '请输入', trigger: 'blur'}],
    punishingAuthorityName: [{required: true, message: '请选择', trigger: 'change'}],
    illegalDate: [{required: true, message: '请选择', trigger: 'change'}],
    typeName: [{required: true, message: '请选择', trigger: 'change'}],
    location: [{required: true, message: '请输入', trigger: 'blur'}],
    illegalFact: [{required: true, message: '请输入', trigger: 'blur'}],
    recognitionBasisName: [{required: true, message: '请选择', trigger: 'change'}],
    penaltyBasisName: [{required: true, message: '请选择', trigger: 'change'}],
    punishmentDecisionDate: [{required: true, message: '请输入', trigger: 'blur'}],
    confiscationAmount: [{required: true, message: '请输入', trigger: 'blur'}],
    punishmentContent: [{required: true, message: '请输入', trigger: 'blur'}],
  }
  private dataInfo = this.initForm();
  private mode = "";

  mounted() {
    const userData = this.$store.state.AuthedUser;
    this.userData = userData;
    this.loadData();
  }

  reset() {
    this.queryParams.start = '';
    this.queryParams.end = '';
    this.queryParams.punishStart = '';
    this.queryParams.punishEnd = '';
    this.queryParams.typeName = '';
    this.queryParams.recognitionBasisName = '';
    this.queryParams.punishingAuthorityName = '';
    this.queryParams.documentNumber = '';
    this.loadData();
  }

  initForm() {
    return {
      punishedUnit: '',
      punishedUnitNameId: '',
      punishedUnitName: '',
      documentNumber: '',
      punishingAuthority: '',
      punishingAuthorityName: '',
      illegalDate: '',
      typeName: '',
      location: '',
      illegalFact: '',
      recognitionBasis: '',
      recognitionBasisName: '',
      penaltyBasis: '',
      penaltyBasisName: '',
      punishmentDecisionDate: '',
      confiscationAmount: '',
      punishmentContent: '',
    }
  }

  loadData() {
    this.clearSelectedTable();
    this.loading = true;
    integrityApi.pagePunish(this.queryParams).then((r: any) => {
      this.loading = false;
      const res = r.data;
      if (res.result === 0) {
        this.queryParams.total = res.data.total;
        this.dataList = res.data.records;
      }
    }).catch(() => {
      this.loading = false;
    })
  }

  pageSizeChange(val: number) {
    this.queryParams.size = val;
    this.loadData();
  }

  pageCurrentChange(val: number) {
    this.queryParams.current = val;
    this.loadData();
  }

  indexMethod(index: any) {
    return (this.queryParams.current - 1) * this.queryParams.size + index + 1;
  }

  onDelete(){
    if(this.isCheckedOne()){
      this.$confirm('确定要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const dataInfo = this.selectedItems[0] as any;
        integrityApi.deletePunish({id: dataInfo.id, punishedUnit: dataInfo.punishedUnit}).then((r: any) => {
          if(r.data.result === 0){
            this.$message.success("删除成功！");
            this.loadData();
          }
        });
      });
    }
  }

  onView() {
    if(this.isCheckedOne()){
      this.dataInfo = this.initForm();
      this.mode = "view";
      this.dataInfo = JSON.parse(JSON.stringify(this.selectedItems[0]));
      this.showAddDialog = true;
    }
  }

  onClickTableView(row: any){
    this.dataInfo = this.initForm();
    this.mode = "view";
    this.dataInfo = JSON.parse(JSON.stringify(row));
    this.showAddDialog = true;
  }

  openAddDialog() {
    this.dataInfo = this.initForm();
    this.dataInfo.punishingAuthorityName = this.userData.organizationName;
    this.dataInfo.punishingAuthority = this.userData.organizationId;
    this.mode = 'save';
    this.showAddDialog = true;
  }

  onClose() {
    this.dataInfo = this.initForm();
    let form = this.$refs.form as HTMLFormElement;
    form.resetFields();
    this.mode = '';
    this.showAddDialog = false;
  }

  onSave() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        integrityApi.addPunish(this.dataInfo).then((r: any) => {
          if (r.data.result === 0) {
            this.$message.success("操作成功！");
            this.loadData();
            this.onClose();
          }
        });
      }
    });
  }

  private selectedItems = [];
  onSelectItem(selection: any, row: any) {
    this.selectedItems = selection;
  }

  isCheckedOne(){
    if(this.isChecked()){
      if(this.selectedItems.length !== 1){
        this.$message.error("请先选择一条记录");
        return false;
      }
    }
    return true;
  }

  isChecked(){
    if(!this.selectedItems || this.selectedItems.length === 0){
      this.$message.error("请先选择一条记录");
      return false;
    }

    return true;
  }

  changeOrg(val: any) {
    this.dataInfo.punishedUnit = val.mechanismId;
    this.dataInfo.punishedUnitName = val.mechanismName;
  }
  clearSelectedTable(){
    this.selectedItems = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
  }

  // dictMap = {};
  // getDict() {
  //   return dictApi.listDictItem({
  //     typeCode: "hylb"
  //   }).then(r => {
  //     if (r.data.result === 0) {
  //       this.dictMap = r.data.data;
  //     }
  //   })
  // }

  // 认定依据选择
  outputDataRecognition(e: any) {
    this.dataInfo.recognitionBasisName += e;
  }
  // 处罚依据选择
  outputDataPenalty(e: any) {
    this.dataInfo.penaltyBasisName += e;
  }
}
